import { formatReviewReason } from '@/modules/projects/labels'
import { needsReview } from '@/modules/projects/status'
import type { StatementSegment } from '@/modules/projects/stores'

export const ReviewReason = ({ segment }: { segment: StatementSegment }) => {
  const sentence = formatReviewReason(segment.reconciliationDetail?.why?.reason)
  if (!needsReview(segment) || !sentence) return null

  return <p className="text-sm text-amber-700">{sentence}</p>
}
